// extracted by mini-css-extract-plugin
module.exports = {"scale":"SurveyStatisticsUtils_scale__18rBC","cell":"SurveyStatisticsUtils_cell__3pTe7"};